export class NumericUtils {
    public static round2Dec(input:number):number {
        return Math.round((input + Number.EPSILON) * 100) / 100;
    }
}